import { put, SagaGenerator, takeLatest } from "typed-redux-saga";
import { Action, AnyAction } from "typescript-fsa";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

export const SELECT_FILE_IMPORT_FILE_ACTIVITY = "SELECT_XML_IMPORT_FILE_ACTIVITY";
export const FILE_READ_PAYLOAD = "readXML";

/**
 * Reagiert auf den Buttonklick zum XML-Auslesen und zeigt einen modalen Dialog zur XML-Auswahl
 */
export function* readFileSaga(): SagaGenerator<void> {
	yield* takeLatest((action: AnyAction) => {
		return (
			FormEngineActions.event.match(action) &&
			Events.eventButtonTriggered.match(action.payload.engineEvent) &&
			FILE_READ_PAYLOAD === action.payload.engineEvent.payload.name
		);
	}, handle);
}

type EventAction = Action<FormEngineActions.FormEngineEventActions>;
function* handle(action: EventAction): SagaGenerator<void> {
	const activityDescriptor = {
		modal: "readXMLModal"
	};
	yield* put(
		ActivityActions.create({
			activityDescriptor,
			initiatingActivityId: action.payload.activityId,
			activityId: SELECT_FILE_IMPORT_FILE_ACTIVITY,
			loadingState: "without"
		})
	);
}
